import { render, staticRenderFns } from "./SubscriptionNumberDetails.vue?vue&type=template&id=1a2d154d&scoped=true&"
import script from "./SubscriptionNumberDetails.vue?vue&type=script&lang=js&"
export * from "./SubscriptionNumberDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2d154d",
  null
  
)

export default component.exports